import { z } from "zod";

export const createBankSchema = z.object({
    account_name: z.string().min(1, "Account name is required"),
    account_number: z.string().min(1, "Account number is required"),
    bank_name: z.string().min(1, "Bank name is required"),
    property_id: z.string().uuid(),
});

export type CreateBankFormData = z.infer<typeof createBankSchema>;
